export default __webpack_public_path__ + "static/media/simple-play-white.8207571e.svg";